export default "__VITE_ASSET__D1lbt6vL__"